// Desktop navigation
document.addEventListener("DOMContentLoaded", function () {

// Check if new navigation is in use current website or not
const newDesktopNav = document.querySelector('.new-desktop-navigation');

// Get elements
// Main Desktop Navigation elements
const navSearchContainer = document.getElementById('navDesktopSearchContainer');
const navSearchInput = document.getElementById('desktopNavSearchInput');

if (newDesktopNav) {
// Desktop navigation search element opening and closing code
document.addEventListener('click', function(event) {
    var searchBarDesktop = document.getElementById('navDesktopSearchContainer');
    var searchElement = document.getElementById('navDesktopSearch');
    var isClicked = searchBarDesktop.contains(event.target);

    if (!isClicked) {
        navSearchInput.classList.remove('open-search');
        navSearchContainer.classList.remove('open-search-container');    
        var str = '<a id="navDesktopSearch" class="search-closed"><span class="iconify" data-icon="mdi:magnify" data-inline="false"></span></a>';
        var Obj = document.getElementById('navDesktopSearch');
        return Obj.outerHTML = str; 
      } 
      if (isClicked && searchElement.classList.contains("search-closed")) {
        var str = '<button id="navDesktopSearch" type="submit" class="desktop-navigation-search-button"><span class="iconify" data-icon="mdi:magnify" data-inline="false"></span></button>';
        var Obj = document.getElementById('navDesktopSearch'); 
        navSearchInput.classList.add('open-search');
        navSearchContainer.classList.add('open-search-container');        
        return Obj.outerHTML=str;    
      }
      else {

      }
    
});

// Desktop navigation language element opening and closing code
var languageMenuDropdown = document.getElementById('languageMenuDropdown');
if (languageMenuDropdown) {
document.addEventListener('click', function(event) {
      var languageMenuIsClicked = languageMenuDropdown.contains(event.target);
      if (languageMenuIsClicked) {
          document.getElementById('languageMenuItems').classList.add('open-language-menu');
        } 
        else {
          document.getElementById('languageMenuItems').classList.remove('open-language-menu');
        }
    });
}
    
    } // End of checking 

}); // End of desktop listener

document.addEventListener('click', function(event) {
    const container = document.querySelector('.has-login-button');
    const button = document.querySelector('.nav-login-button');
    if (container) {
    const isClicked = container.contains(event.target);
    if (isClicked) {
        // User has clicked inside container, do nothing
      } 
      else {
       // User clicked some where on the document, so remove items
        var divElement = button.nextElementSibling;
            divElement.classList.remove('open-login-order-menu');
            button.classList.remove('menu-is-open');
      }  
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.has-login-button');
    const button = document.querySelector('.nav-login-button');
    if (container) {
    button.addEventListener('click', function() {
        const divElement = this.nextElementSibling;
            divElement.classList.add('open-login-order-menu');
            button.classList.add('menu-is-open');
 
    });
}
});

document.addEventListener('click', function(event) {
    const container = document.querySelector('.has-get-to-know-button');
    const button = document.querySelector('.nav-get-to-know-button');
    if (container) {
    const isClicked = container.contains(event.target);
    if (isClicked) {
        // User has clicked inside container, do nothing
      } 
      else {
       // User clicked some where on the document, so remove items
        var divElement = button.nextElementSibling;
            divElement.classList.remove('open-login-order-menu');
            button.classList.remove('menu-is-open');
      } 

    }
});

document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.has-get-to-know-button');
    const button = document.querySelector('.nav-get-to-know-button');
    if (container) {
    button.addEventListener('click', function(event) {
        const divElement = this.nextElementSibling;
            divElement.classList.add('open-login-order-menu');
            button.classList.add('menu-is-open');
 
        });
    }
});



// Mobile navigation
document.addEventListener("DOMContentLoaded", function () {


// Check if new navigation is in use current website or not
const newMobileNav = document.querySelector('.new-mobile-navigation');

// Get elements
// Main Mobile Navigation elements
const mobileNav = document.getElementById('newMobileNavigation');
const openMobileNav = document.querySelector('.open-mobile-nav');
const closeMobileNav = document.querySelectorAll('.close-mobile-nav'); 
const topLevelNavItem = document.getElementsByClassName('mobile-nav-item-level-0');
const goBackButton = document.getElementById('goBackMainView');
const navCurrentTitle = document.getElementById('navCurrentTitle');
const openOAR = document.querySelectorAll('.mobile-open-second-level'); 

// Search icon
const openMobileSearch = document.getElementById('openMobileSearch');
const mobileSearchOverlay = document.getElementById('mobileSearchOverlay');

// Language icon
const openMobileLanguage = document.getElementById('openMobileLanguage');
const mobileLanguageOverlay = document.getElementById('mobileLanguageOverlay');

// Login icon
const openMobileLogin = document.getElementById('openMobileLogin');
const mobileLoginOverlay = document.getElementById('mobileLoginOverlay');

// Others
const bodyTag = document.getElementsByTagName( 'body' )[0]; 

if (newMobileNav) {
   // Open second level navigation on mobile + get title to top of second level [BUG FOUND: IF USER CLICK "ARROW", IT WILL ADD "UNDEFINED"]
    for (const topLevel of topLevelNavItem) {
        topLevel.addEventListener('click', (event) => {
            const getTitle = event.currentTarget.querySelectorAll(".mobile-nav-item-level-0 p")[0];
            navCurrentTitle.innerText = getTitle.innerText;     
            event.currentTarget.parentNode.querySelector(".mobile-menu-level-1").classList.add('open-second-level');
            goBackButton.classList.add('show-go-back-button');
        });
    }


    /* Open mobile navigation from hamburger */
    openMobileNav.addEventListener('click', () => {
        openMobileNav.classList.add('is-active');
        mobileNav.classList.add('on-active');
        bodyTag.classList.add('no-scroll');
    });


    /* Open Search navigation */
    openMobileSearch.addEventListener('click', () => {
        mobileSearchOverlay.classList.add('on-active');
        bodyTag.classList.add('no-scroll');
    });


     /* Open Language navigation */ 
     if (openMobileLanguage) {
    openMobileLanguage.addEventListener('click', () => {
        mobileLanguageOverlay.classList.add('on-active');
        bodyTag.classList.add('no-scroll');
    });
     }


     /* Open Login navigation */ 
     openMobileLogin.addEventListener('click', () => {
        mobileLoginOverlay.classList.add("on-active");
        bodyTag.classList.add('no-scroll');
    }); 

    /* Open Login and order second level of navigation */
    for (const openSecondLevel of openOAR) {
        openSecondLevel.addEventListener('click', (event) => {
            const getTitleu = event.currentTarget;
            navCurrentTitle.innerText = getTitleu.innerText; 
            event.currentTarget.parentNode.querySelector(".order-and-login-menu-level-1").classList.add('open-second-level');
            goBackButton.classList.add('show-go-back-button');
        });
    }


    // Close mobile navigation menu from "X" and reset all navigation classes
    for (const closeButton of closeMobileNav) {
    closeButton.addEventListener('click', () => {
        openMobileNav.classList.remove("is-active");
        mobileNav.classList.remove("on-active");
        mobileSearchOverlay.classList.remove("on-active");
        if (mobileLanguageOverlay) {
        mobileLanguageOverlay.classList.remove("on-active");
        }
        mobileLoginOverlay.classList.remove("on-active");
        bodyTag.classList.remove("no-scroll");
        goBackButton.classList.remove('show-go-back-button');
        navCurrentTitle.innerText = '';
        document.querySelectorAll('.mobile-menu-level-1').forEach(function(deleteOverlay) {
            deleteOverlay.classList.remove('open-second-level');
        });
        document.querySelectorAll('.order-and-login-menu-level-1').forEach(function(deleteOverlay) {
            deleteOverlay.classList.remove('open-second-level');
        });
    });
    }


// Go back to main view "<=" button
    goBackButton.addEventListener('click', () => {
        goBackButton.classList.remove('show-go-back-button');
        navCurrentTitle.innerText = '';
        const rsl = document.querySelectorAll('.mobile-menu-level-1'); 
            for (const removeSecondLevel of rsl) {
                removeSecondLevel.classList.remove('open-second-level');
            }
        const odr = document.querySelectorAll('.order-and-login-menu-level-1'); 
            for (const removeSecondLevel of odr) {
                removeSecondLevel.classList.remove('open-second-level');
            }
    });
} // End of checking
});